import { z } from 'zod';

export const DecisionSupportFiltersSchema = z.object({
  clientId: z.string(),
  scope: z.enum(['applications', 'interviews']).default('applications'),
  month: z.string().nullable().optional(),
  startDate: z.string().nullable().optional(),
  endDate: z.string().nullable().optional(),
  jobId: z.string().nullable().optional(),
});

export const DecisionSupportQuadrantPointSchema = z.object({
  applicationId: z.string(),
  candidateId: z.string().nullable(),
  candidateName: z.string(),
  stage: z.string(),
  finalScore: z.number().int().min(0).max(100),
  confidence: z.number().int().min(0).max(100),
  x: z.number(),
  y: z.number(),
  quadrant: z.enum([
    'high_fit_high_confidence',
    'high_fit_low_confidence',
    'low_fit_high_confidence',
    'low_fit_low_confidence',
  ]),
  strengths: z.array(z.string()).default([]),
  risks: z.array(z.string()).default([]),
  jobId: z.string(),
  jobTitle: z.string(),
});

export const DecisionSupportInsightCardSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  tone: z.enum(['positive', 'neutral', 'warning']),
});

export const DecisionSupportReportSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  scope: z.enum(['applications', 'interviews']),
  filters: DecisionSupportFiltersSchema,
  status: z.enum(['queued', 'running', 'completed', 'failed']),
  taskId: z.string().nullable().optional(),
  lastGeneratedAt: z.string().nullable().optional(),
  errorMessage: z.string().nullable().optional(),
  newApplicationsCount: z.number().int().nonnegative(),
  includedCandidatesCount: z.number().int().nonnegative(),
  quadrant: z.object({
    xLabel: z.string(),
    yLabel: z.string(),
    points: z.array(DecisionSupportQuadrantPointSchema),
  }),
  summary: z.object({
    headline: z.string(),
    narrative: z.string(),
    standoutCandidates: z.array(z.string()).default([]),
    cautionFlags: z.array(z.string()).default([]),
  }),
  insightCards: z.array(DecisionSupportInsightCardSchema).default([]),
});

export type DecisionSupportFilters = z.infer<typeof DecisionSupportFiltersSchema>;
export type DecisionSupportQuadrantPoint = z.infer<typeof DecisionSupportQuadrantPointSchema>;
export type DecisionSupportInsightCard = z.infer<typeof DecisionSupportInsightCardSchema>;
export type DecisionSupportReport = z.infer<typeof DecisionSupportReportSchema>;
